 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import LOVE_1 from '@/components/love_1'
 import TITLEPAGE from '@/components/titlepage'
 import WELCOME from '@/components/welcome'
 import CHAPTER001 from '@/components/chapter001'
 import CHAPTER002 from '@/components/chapter002'
 import CHAPTER003 from '@/components/chapter003'
 import CHAPTER004 from '@/components/chapter004'
 import CHAPTER005 from '@/components/chapter005'
 import CHAPTER006 from '@/components/chapter006'
 import CHAPTER007 from '@/components/chapter007'
 import CHAPTER008 from '@/components/chapter008'
 import CHAPTER009 from '@/components/chapter009'
 import CHAPTER010 from '@/components/chapter010'
 import CHAPTER011 from '@/components/chapter011'
 import CHAPTER012 from '@/components/chapter012'
 import CHAPTER013 from '@/components/chapter013'
 import CHAPTER014 from '@/components/chapter014'
 import CHAPTER015 from '@/components/chapter015'
 import CHAPTER016 from '@/components/chapter016'
 import CHAPTER017 from '@/components/chapter017'
 import CHAPTER018 from '@/components/chapter018'
 import CHAPTER019 from '@/components/chapter019'
 import CHAPTER020 from '@/components/chapter020'
 import CHAPTER021 from '@/components/chapter021'
 import CHAPTER022 from '@/components/chapter022'
 import CHAPTER023 from '@/components/chapter023'
 import CHAPTER024 from '@/components/chapter024'
 import CHAPTER025 from '@/components/chapter025'
 import CHAPTER025A from '@/components/chapter025a'
 import CHAPTER025B from '@/components/chapter025b'
 import CHAPTER025C from '@/components/chapter025c'
 import CHAPTER025D from '@/components/chapter025d'
 import CHAPTER025E from '@/components/chapter025e'
 import CHAPTER025F from '@/components/chapter025f'
 import CHAPTER025G from '@/components/chapter025g'
 import CHAPTER025H from '@/components/chapter025h'
 import CHAPTER025I from '@/components/chapter025i'
 import CHAPTER025J from '@/components/chapter025j'
 import CHAPTER025K from '@/components/chapter025k'
 import CHAPTER025L from '@/components/chapter025l'
 import CHAPTER025M from '@/components/chapter025m'
 import CHAPTER025N from '@/components/chapter025n'
 import CHAPTER025O from '@/components/chapter025o'
 import CHAPTER025P from '@/components/chapter025p'
 import CHAPTER026 from '@/components/chapter026'
 import CHAPTER026A from '@/components/chapter026a'
 import CHAPTER026B from '@/components/chapter026b'
 import CHAPTER027 from '@/components/chapter027'
 import LOVE_2 from '@/components/love_2'
 import BIBLIOGRAPHY from '@/components/bibliography'
 import PERSONBLURB from '@/components/personblurb'
 import ADCARD from '@/components/ad-card'
 import NEWSLETTERSIGNUP from '@/components/newsletterSignup'
 import FOOTNOTES from '@/components/footnotes'
 import TOC from '@/components/toc'
 import COPYRIGHT from '@/components/copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/titlepage",
 			"name" : "titlepage",
 			"component" : TITLEPAGE
 		},
 		{
 			"path" : "/welcome",
 			"name" : "welcome",
 			"component" : WELCOME
 		},
 		{
 			"path" : "/chapter001",
 			"name" : "chapter001",
 			"component" : CHAPTER001
 		},
 		{
 			"path" : "/chapter002",
 			"name" : "chapter002",
 			"component" : CHAPTER002
 		},
 		{
 			"path" : "/chapter003",
 			"name" : "chapter003",
 			"component" : CHAPTER003
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js